{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "(spórolj {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} napig ingyen",
    "{amount} off": "{amount} kedvezmény",
    "{amount} off for first {number} months.": "{amount} kedvezmény az első {number} hónapig.",
    "{amount} off for first {period}.": "{amount} kedvezmény eddig: {period}",
    "{amount} off forever.": "{amount} kedvezmény örökké",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% kedvezmény",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "A(z) {memberEmail} cím többé nem kap {newsletterName} hírlevelet",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "A(z) {memberEmail} többé nem kap e-mailt, ha valaki válaszol a hozzászólásaira.",
    "{memberEmail} will no longer receive this newsletter.": "A(z) {memberEmail} többé nem kapja meg ezt a hírlevelet",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} nap ingyen",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Fiók",
    "Account details updated successfully": "A fiók adatai sikeresen frissültek.",
    "Account settings": "Fiók beállítások",
    "Add a personal note": "Személyes jegyzet hozzáadása",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Az ingyenes próbaidőszak lejárta után a kiválasztott csomag normál díját fogjuk felszámolni. A próbaidőszak alatt bármikor lemondhatod az előfizetésedet.",
    "Already a member?": "Már tag vagy?",
    "An error occurred": "Hiba történt.",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Egy nem várt hiba történt! Kérjük, próbáld meg újra, vagy <a>lépj kapcsolatba velünk</a>, ha a hiba fennmarad.",
    "Back": "Vissza",
    "Back to Log in": "Vissza a bejelentkezéshez",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Bármikor lemondható.",
    "Cancel subscription": "Előfizetés lemondása",
    "Canceled": "",
    "Cancellation reason": "Az előfizetés lemondásának oka",
    "Change": "Csere",
    "Change plan": "Csomag cseréje",
    "Check spam & promotions folders": "Ellenőrizd a spam és promóciós mappákat is",
    "Check with your mail provider": "Ellenőrizd az e-mail szolgáltatódnál",
    "Check your inbox to verify email update": "Ellenőrizd a beérkező üzeneteidet az e-mail frissítésének megerősítéséhez",
    "Choose": "Kiválaszt",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Válassz egy másik csomagot",
    "Choose a plan": "Válassz egy csomagot",
    "Choose a tier": "",
    "Choose your newsletters": "Válaszd ki a hírleveleidet",
    "City": "",
    "Click here to retry": "Kattints ide az újrapróbálkozáshoz",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Bezár",
    "Code": "",
    "Comment preferences updated.": "Hozzászólási beállítások frissítve.",
    "Comments": "Hozzászólások",
    "Complimentary": "Ajándék",
    "Confirm": "Jóváhagyás",
    "Confirm cancellation": "Lemondás megerősítése",
    "Confirm subscription": "Előfizetés megerősítése",
    "Contact support": "Kapcsolat",
    "Continue": "Folytatás",
    "Continue subscription": "Előfizetés folytatása",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "A Stripe fizetési tranzakció sikertelen.",
    "Could not sign in. Login link expired.": "A bejelentkezési link lejárt, a regisztráció sikertelen.",
    "Could not update email! Invalid link.": "Hibás link! Az e-mail-cím megváltoztatása sikertelen.",
    "Country": "",
    "Create a new contact": "Új kapcsolat létrehozása",
    "Current plan": "Aktuális csomag",
    "Delete account": "Fiók törlése",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Ez véletlenül történt? Kattints <button>ide</button> a beállításaidhoz.",
    "Don't have an account?": "Még nincs fiókod?",
    "Edit": "Szerkesztés",
    "Email": "E-mail",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Hírlevél",
    "Email newsletter settings updated": "A hírlevél beállításaid frissültek.",
    "Email preferences": "E-mail beállítások",
    "Email preferences updated.": "E-mail beállítások frissítve.",
    "Emails": "E-mailek",
    "Emails disabled": "E-mailek kikapcsolva",
    "Ends {offerEndDate}": "Ajánlat vége: {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Add meg az e-mail-címed",
    "Enter your name": "Neved",
    "Error": "Hiba",
    "Expires {expiryDate}": "Lejár: {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Nem sikerült törölni az előfizetést. Kérjük, próbáld újra",
    "Failed to log in, please try again": "Nem sikerült bejelentkezni. Kérjük, próbáld újra",
    "Failed to log out, please try again": "Nem sikerült kijelentkezni. Kérjük, próbáld újra",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "A fizetési folyamat elakadt. Kérjük, próbáld újra",
    "Failed to send magic link email": "Nem sikerült elküldeni a varázslinket tartalmazó e-mailt",
    "Failed to send verification email": "Nem sikerült elküldeni a megerősítő e-mailt",
    "Failed to sign up, please try again": "Nem sikerült a regisztráció. Kérjük, próbáld újra",
    "Failed to update account data": "Nem sikerült frissíteni a fiókadatokat",
    "Failed to update account details": "Nem sikerült frissíteni a fiókadatokat",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Nem sikerült frissíteni a hírlevél beállításokat",
    "Failed to update subscription, please try again": "Nem sikerült frissíteni az előfizetést. Kérjük, próbáld újra",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Örökké",
    "Free Trial – Ends {trialEnd}": "Ingyenes próbaidőszak — Vége ekkor: {trialEnd}",
    "From": "",
    "Get help": "Segítséget kérek",
    "Get in touch for help": "Írj nekünk",
    "Get notified when someone replies to your comment": "Értesítést kérek, ha valaki válaszol a hozzászólásaimra",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Hogy tetszett ez a cikk?",
    "Help! I'm not receiving emails": "Segítség! Nem kapok e-maileket!",
    "Here are a few other sites you may enjoy.": "Itt van pár weboldal, amelyek szintén tetszhetnek.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ha egy hírlevél spamként van bejelölve, az e-mailek automatikusan letiltásra kerülnek az adott címre, hogy biztosan ne kapj több nem kívánt üzenetet.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ha a spam panasz véletlen volt, vagy újra szeretnéd kapni az e-maileket, akkor az előző képernyőn látható gombra kattintva újra feliratkozhatsz.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ha lemondod most az előfizetésedet, továbbra is hozzáférsz az előfizetői tartalmakhoz eddig: {periodEnd}",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ha céges vagy kormányzati e-mail-fiókod van, akkor lépj kapcsolatba a fiók-adminisztrátorral, hogy engedélyezze az e-mailek fogadását az alábbi e-mail-címről: {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "A bejelentkezéshez szükséges linket elküldtük a megadott e-mail-címre. Ha nem érkezik meg 3 percen belül, ellenőrizd a spam mappát!",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ha újra szeretnél e-maileket kapni tőlünk, kérjük ellenőrizd az e-mail-címed, és kattints az újrafeliratkozásra az előző képernyőn.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Íme pár dolog, amiket ellenőrizhetsz, ha nem kapsz tőlünk e-maileket.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Ha a fenti lehetőségeket ellenőrizted, és továbbra sem kapsz e-maileket, kérjük, lépj kapcsolatba velünk az alábbi e-mail-címen: {supportAddress}",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Amennyiben tartós hiba lép fel egy hírlevél küldése közben, az e-mailek letiltásra kerülnek a fiókon.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Az e-mail kliensben add hozzá {senderEmail}-t a kapcsolatok listához. Ez jelezni fogja az e-mail szolgáltatónak, hogy az erről a címről érkező e-maileket megbízhatónak kell tekinteni.",
    "Invalid email address": "Érvénytelen e-mail-cím",
    "Invalid verification code": "",
    "Jamie Larson": "Kiss Sára",
    "jamie@example.com": "sarakiss@pelda.hu",
    "Less like this": "Kevesebb ilyet",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Győződj meg róla, hogy az e-mailek véletlenül nem kerülnek-e a Spam vagy Promóciók mappába az e-mail-fiókodban. Ha ez történik, kattints a 'Nem spam' és/vagy az 'Áthelyezés a Beérkezők közé' lehetőségekre.",
    "Manage": "Kezelés",
    "Maybe later": "Talán később",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "Ehhez az e-mail szolgáltatóhoz tartozó tagság jelenleg korlátozott.",
    "Memberships unavailable, contact the owner for access.": "A feliratkozás nem elérhető! Kérjük, lépj kapcsolatba a weboldal tulajdonosával a hozzáférésért.",
    "month": "hónap",
    "Monthly": "Havi",
    "More like this": "Még több ilyet",
    "More options": "",
    "Name": "Név",
    "Need more help? Contact support": "További segítségre van szükséged? Lépj velünk kapcsolatba",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "A hírlevelek két okból tilthatók le a fiókodban: egy korábbi e-mail spamként lett megjelölve, vagy egy e-mail küldési kísérlet tartós hibához (visszapattanáshoz) vezetett.",
    "No member exists with this e-mail address.": "Ehhez az e-mail-címhez nem tartozik fiók.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Nem kapsz e-maileket?",
    "Now": "",
    "Now check your email!": "Ellenőrizd a postafiókodat most!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Miután újra feliratkoztál, de még mindig nem látod az e-maileket a beérkező mappádban, ellenőrizd a spam mappát is. Néhány e-mail szolgáltató nyilvántartást vezet korábbi spam panaszokról, és továbbra is megjelölheti az e-maileket. Ezután a legújabb hírlevelet jelöld meg 'Nem spamként', hogy visszakerüljön a beérkező levelek mappába.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Tartós hiba (visszapattanás)",
    "Phone number": "Telefonszám",
    "Plan": "Csomag",
    "Plan checkout was cancelled.": "A csomag fizetési tranzakciója törölve lett",
    "Plan upgrade was cancelled.": "A csomag frissítése törölve lett",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Az ingyenes (ajándék) csomagod módosításáért kérjük, lépj velünk kapcsolatba az alábbi e-mail-címen: {supportAddress}",
    "Please enter {fieldName}": "Kérjük, add meg {fieldName}",
    "Please fill in required fields": "Kérjük, töltsd ki az összes mezőt",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "E-mailek aktiválása",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Ajánlott oldalak",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Megújul {price} áron",
    "Resume subscription": "",
    "Retry": "Újra",
    "Save": "Mentés",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Bejelentkezési link küldése...",
    "Sending...": "Küldés...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Az összes mutatása",
    "Sign in": "Bejelentkezés",
    "Sign out": "Kijelentkezés",
    "Sign up": "Regisztráció",
    "Signup error: Invalid link": "Regisztrációs hiba: érvénytelen link",
    "Signups from this email domain are currently restricted.": "Ehhez az e-mail szolgáltatóhoz tartozó regisztráció jelenleg nem engedélyezett.",
    "Something went wrong, please try again later.": "Valami nem sikerült. Kérjük, próbáld újra.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Sajnáljuk, de az ajánlott oldalak most nem elérhetőek.",
    "Sorry, that didn’t work.": "Sajnáljuk, ez nem működött.",
    "Spam complaints": "Spam panaszok",
    "Start {amount}-day free trial": "{amount} napos próbaidőszak kezdése",
    "Starting {startDate}": "Kezdet: {startDate}",
    "Starting today": "Ma kezdődik",
    "State": "",
    "Submit feedback": "Visszajelzés küldése",
    "Subscribe": "Feliratkozás",
    "Subscribed": "Feliratkozva",
    "Subscription plan updated successfully": "Az előfizetői csomag sikeresen frissült.",
    "Success": "Ez sikerült!",
    "Success! Check your email for magic link to sign-in.": "Ez sikerült! Nézd meg az e-mailedet a bejelentkezéshez szükséges linkhez.",
    "Success! Your account is fully activated, you now have access to all content.": "Ez sikerült! A fiókod aktiváltuk, most már hozzáférsz az összes tartalomhoz.",
    "Success! Your email is updated.": "Ez sikerült! Az e-mailedet frissítettük.",
    "Successfully unsubscribed": "Sikeres leiratkozás",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Köszönjük, hogy előfizettél! Olvasás előtt még ajánlunk néhány oldalt, amelyek tetszhetnek.",
    "Thank you for your support": "Köszönjük a támogatásodat",
    "Thank you for your support!": "Köszönjük a támogatásodat!",
    "Thanks for the feedback!": "Köszönjük a visszajelzést!",
    "That didn't go to plan": "Hiba történt",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Ezzel az e-mail-címmel regisztráltál nálunk: {memberEmail} — ha ez nem helyes, frissítheted a <button>fiókbeállításoknál</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Probléma volt a visszajelzés küldésénél. Kérjük, próbáld újra kicsit később.",
    "There was an error cancelling your subscription, please try again.": "Hiba történt az előfizetés lemondásánál. Kérjük, próbáld újra.",
    "There was an error continuing your subscription, please try again.": "Hiba történt az előfizetés folytatatásának kérésekor. Kérjük, próbáld újra.",
    "There was an error processing your payment. Please try again.": "Hiba történt a fizetési folyamatnál. Kérjük, próbáld újra.",
    "There was an error sending the email, please try again": "Hiba történt az e-mail küldésénél. Kérjük, próbáld újra.",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "A weboldal csak meghívóval látogatható. Meghívóért lépj kapcsolatba a weboldal tulajdonosával.",
    "This site is not accepting donations at the moment.": "Ez az oldal jelenleg nem fogad adományokat.",
    "This site is not accepting payments at the moment.": "A weboldal jelenleg nem fogad el fizetést.",
    "This site only accepts paid members.": "Ez az oldal csak fizetős tagokat fogad.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "A regisztráció befejezéséhez kérjük, kattints az e-mailben kapott linkre. Ha a link nem érkezik meg 3 percen belül, kérjük, ellenőrizd a spam mappát.",
    "To continue to stay up to date, subscribe to {publication} below.": "Ha a jövőben is naprakész szeretnél lenni, iratkozz fel ide {publication}",
    "Too many attempts try again in {number} days.": "Túl sok próbálkozás történt. Próbáld meg ennyi nap múlva újra: {number}",
    "Too many attempts try again in {number} hours.": "Túl sok próbálkozás történt. Próbáld meg ennyi óra múlva újra: {number}",
    "Too many attempts try again in {number} minutes.": "Túl sok próbálkozás történt. Próbáld meg ennyi perc múlva újra: {number}",
    "Too many different sign-in attempts, try again in {number} days": "Túl sok, különböző bejelentkezési kísérlet történt, próbáld meg újra ennyi nap múlva: {number}",
    "Too many different sign-in attempts, try again in {number} hours": "Túl sok, különböző bejelentkezési kísérlet történt, próbáld meg újra ennyi óra múlva: {number}",
    "Too many different sign-in attempts, try again in {number} minutes": "Túl sok, különböző bejelentkezési kísérlet történt, próbáld meg újra ennyi perc múlva: {number}",
    "Too many sign-up attempts, try again later": "Túl sok regisztrációs próbálkozás, próbáld újra később.",
    "Try free for {amount} days, then {originalPrice}.": "Próbáld ki ingyen {amount} napig, utána {originalPrice}",
    "Unable to initiate checkout session": "Nem sikerült elindítani a fizetési munkamenetet",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Előfizetéssel az összes hírlevélhez hozzáférsz.",
    "Unsubscribe from all emails": "Leiratkozás minden e-mailről",
    "Unsubscribed": "Sikeres leiratkozás",
    "Unsubscribed from all emails.": "Leiratkozás minden e-mailről.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Az e-mailekről történő leiratkozás nem szünteti meg az előfizetésed ide: {title}",
    "Update": "Frissítés",
    "Update your preferences": "Beállításaid mentése",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "A megerősítő linket elküldtük. Kérjük, ellenőrizd a postafiókod.",
    "Verify your email address is correct": "Ellenőrizd, hogy az e-mail-címed helyes-e.",
    "Verifying...": "",
    "View plans": "Csomagok megtekintése",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Ehhez az e-mail-címhez nem tartozik fiók. Kérjük, lépj kapcsolatba a weboldal tulajdonosával.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Üdv újra, {name}!",
    "Welcome back!": "Üdvözlünk újra!",
    "Welcome to {siteTitle}": "Üdvözlünk — {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Amikor egy postaláda nem fogad egy e-mailt, az általában visszapattanás. Sok esetben ez lehet ideiglenes. Azonban visszapattanhat az e-mail akkor is, ha az e-mail-cím érvénytelen vagy nem létezik.",
    "Why has my email been disabled?": "Miért tiltották le az e-mail-címem?",
    "X (Twitter)": "",
    "year": "év",
    "Yearly": "Éves",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Jelenleg ingyenes tagságod van. A teljes hozzáférésért válts előfizetéses csomagra.",
    "You have been successfully resubscribed": "Sikeresen feliratkoztál újra",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Jelenleg nem kapsz e-maileket",
    "You're not receiving emails": "Nem kapsz e-maileket",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Nem kapsz e-maileket, mert vagy spamnek jelöltél egy tőlünk kapott e-mailt, vagy mert a megadott e-mail-cím nem tud üzeneteket fogadni.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Sikeresen bejelentkeztél.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Sikeresen bejelentkeztél ide:  <strong>{siteTitle}</strong>",
    "Your account": "Fiókod",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Az e-mail-címedet nem sikerült újra regisztrálni. Kérjük, próbáld újra",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "A visszajelzésed segít abban, hogy miről írjunk",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Az előfizetésed lejár ekkor: {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Az előfizetésed megújul ekkor: {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Az előfizetésed ekkor indul: {subscriptionStart}"
}
